/**
 * @desc MQ推送日志失败回调
 */
const URL = "/rantion-aider";
import http, { updateResponse } from "@/http";
export function request(body: defs.aider.SendFailParamDto, options?: any) {
  return updateResponse(
    http(URL + `/log/message/sendFail`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
